import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { coachUserRoleArray } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';

@Component({
  selector: 'bxl-runner-training-ideas',
  templateUrl: 'runner-training-ideas.component.html',
  styleUrls: ['runner-training-ideas.component.scss']
})
export class RunnerTrainingIdeasComponent implements OnInit {
  initialized = false;
  clientUserId: number;
  hasCoachRole: boolean;


  constructor(private router: Router, private auth: AuthenticationService, private breadcrumbs: BreadcrumbsService) { }

  ngOnInit(): void {
    this.breadcrumbs.SetSecondaryBreadcrumb('My Library', 'my-library', []);
    this.auth.fetchUserProfile().subscribe(user => {
      this.clientUserId = user.id;
      this.hasCoachRole = this.auth.hasClaimForRole(coachUserRoleArray);
      this.initialized = true;
    });
  }
}
